import React from 'react';
import { useWatch } from 'react-hook-form';
import { RhNumberField } from '../../../../../../../../dum';
import { isCalibreRequired } from '../../../validation/is-calibre-required';
import { IProduct } from '../../../product-form';
import { FIELD_LABELS, shortLabel } from '../../../../../../../../../helpers';

const ORDER_PRODUCTION_TYPE_NAME: keyof IProduct = 'order_production_type_id';

export function CalibreInput() {
    const order_production_type_id = useWatch({
        name: ORDER_PRODUCTION_TYPE_NAME,
    });
    const inputName: keyof IProduct = 'calibre';

    if (!isCalibreRequired({ order_production_type_id })) {
        return null;
    }

    return (
        <RhNumberField
            name={inputName}
            label={shortLabel(FIELD_LABELS.calibre)}
        />
    );
}
